import { noop } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { filterToValidAttributes } from '@zocdoc/dom-property';

import { Arrow } from '../../icons';
import CreateResponsiveStyledComponent from '../../mixins/CreateResponsiveStyledComponent';

import * as styled from './control-primitives';

import {
    COMPONENT_SIZE_DEFNS,
    TIMESGRID_DESKTOP_CONFIG,
    SIZE_TO_NUM_COLS,
} from '../constants/ViewConstants';

import CreateTimesGridControls from './CreateTimesGridControls';

class DesktopTimesGridControls extends PureComponent {
    static propTypes = {
        dates: PropTypes.array,
        isFirstPossibleDateFrame: PropTypes.bool,
        nextBtnClicked: PropTypes.func,
        prevBtnClicked: PropTypes.func,
        sizeId: PropTypes.string,
    };

    static defaultProps = {
        isFirstPossibleDateFrame: false,
        nextBtnClicked: noop,
        prevBtnClicked: noop,
    };

    render() {
        return (
            <styled.DesktopWrapper
                {...filterToValidAttributes(this.props)}
                data-test="ap-desktop-controls"
            >
                {this.renderPreviousArrow()}
                {this.props.dates.slice(0, this.getNumDaysToDisplay()).map(this.maybeRenderDay)}
                {this.renderNextArrow()}
            </styled.DesktopWrapper>
        );
    }

    maybeRenderDay = date => {
        return (
            <styled.DesktopDayColumn
                key={date.format()}
                data-test="ap-desktop-controls-day"
                sizeId={this.props.sizeId}
            >
                <div>{date.format('ddd')}</div>
                <styled.DesktopStyledDate>{date.format('MMM D')}</styled.DesktopStyledDate>
            </styled.DesktopDayColumn>
        );
    };

    renderPreviousArrow() {
        const numDays = this.getNumDaysToDisplay();

        return (
            <styled.DesktopNavigationToggle
                data-test="ap-desktop-controls-prev"
                disabled={this.props.isFirstPossibleDateFrame}
                onClick={this.handlePrevArrowClick}
                title={`Show the previous ${numDays} days (starting with ${moment(this.props.dates[0]).subtract(numDays, 'days').format('ddd, MMM D')})`}
            >
                <Arrow
                    color="currentColor"
                    direction="left"
                    height={14.58}
                />
            </styled.DesktopNavigationToggle>
        );
    }

    renderNextArrow() {
        const numDays = this.getNumDaysToDisplay();

        return (
            <styled.DesktopNavigationToggle
                data-test="ap-desktop-controls-next"
                disabled={this.props.disableNextArrow}
                onClick={this.handleNextArrowClick}
                title={`Show the next ${numDays} days (starting with ${moment(this.props.dates[0]).add(numDays, 'days').format('ddd, MMM D')})`}
            >
                <Arrow
                    color="currentColor"
                    direction="right"
                    height={14.58}
                />
            </styled.DesktopNavigationToggle>
        );
    }

    getNumDaysToDisplay() {
        return SIZE_TO_NUM_COLS[this.props.sizeId];
    }

    handlePrevArrowClick = () => this.props.prevBtnClicked(this.getNumDaysToDisplay())
    handleNextArrowClick = () => this.props.nextBtnClicked(this.getNumDaysToDisplay())
}

/* eslint-disable babel/new-cap */
export default (
    CreateResponsiveStyledComponent(COMPONENT_SIZE_DEFNS)(
        CreateTimesGridControls(TIMESGRID_DESKTOP_CONFIG)(
            DesktopTimesGridControls
        )
    )
);
